import { FIELD_NAME, initialValueCallWoman } from 'helpers';
import { EOrderStep, TRecommendFemale } from 'types';
import { create } from 'zustand';

type State = {
  orderStep: EOrderStep;
  orderFormState: Record<string, string>;
  listSelectedGirl: TRecommendFemale[];
  isPendingOrder?: boolean;
  /** Setting credit target from chat "Play with this girl". Not from location.state. */
  fixedFemaleId: number | null;
  /** PRIVATE channel to return to when backing out of CALL_WOMAN. */
  sourceChannelId: string | null;
};

type Actions = {
  setOrderStep: (value: EOrderStep) => void;
  setOrderFormState: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >;
  setListSelectedGirl: React.Dispatch<React.SetStateAction<TRecommendFemale[]>>;
  redirectOrderStep: () => void;
  setIsPendingOrder: (value: boolean) => void;
  setFixedFemaleId: (value: number | null) => void;
  setSourceChannelId: (value: string | null) => void;
  clearSettingOrderMeta: () => void;
};

const useOrderStore = create<State & Actions>((set) => ({
  listSelectedGirl: [],
  orderFormState: initialValueCallWoman,
  orderStep: EOrderStep.ORDER_METHOD,
  isPendingOrder: false,
  fixedFemaleId: null,
  sourceChannelId: null,
  setOrderStep: (value: EOrderStep) => set(() => ({ orderStep: value })),
  setOrderFormState: (value: React.SetStateAction<Record<string, string>>) =>
    set((state) => ({
      orderFormState:
        typeof value === 'function' ? value(state.orderFormState) : value,
    })),
  setListSelectedGirl: (value: React.SetStateAction<TRecommendFemale[]>) =>
    set((state) => ({
      listSelectedGirl:
        typeof value === 'function' ? value(state.listSelectedGirl) : value,
    })),
  redirectOrderStep: () =>
    set((state) => ({
      orderStep:
        state.orderStep === EOrderStep.ORDER_DETAIL &&
        !!state.orderFormState[FIELD_NAME.MEETING_ADDRESS].trim()
          ? state.orderStep + 1
          : state.orderStep,
    })),
  setIsPendingOrder: (value: boolean) => set(() => ({ isPendingOrder: value })),
  setFixedFemaleId: (value: number | null) =>
    set(() => ({ fixedFemaleId: value })),
  setSourceChannelId: (value: string | null) =>
    set(() => ({ sourceChannelId: value })),
  clearSettingOrderMeta: () =>
    set(() => ({ fixedFemaleId: null, sourceChannelId: null })),
}));

export default useOrderStore;
